import React from 'react'
import { connect } from 'react-redux'
import { CardDeck, Card } from 'react-bootstrap';
import washHands from '../images/COVID-Icons_Wash.png';
import touchFace from '../images/COVID-Icons_Hand.png';
import cough from '../images/COVID-Icons_Cough.png';
import distancing from '../images/COVID-Icons_Distance.png';

class CovidInfo extends React.Component {

    render() {
        return (
            <div>
                <CardDeck>
                    <Card>
                        <Card.Img variant="top" src={washHands} />
                        <Card.Body>
                            <Card.Text>
                            {this.props.strings.ICON_WASHHANDS}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Img variant="top" src={touchFace} />
                        <Card.Body>
                            <Card.Text>
                            {this.props.strings.ICON_TOUCHFACE}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Img variant="top" src={cough} />
                        <Card.Body>
                            <Card.Text>
                            {this.props.strings.ICON_COUGH}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Img variant="top" src={distancing} />
                        <Card.Body>
                            <Card.Text>
                            {this.props.strings.ICON_DISTANCING}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </CardDeck>
                <p>{this.props.strings.INFO_CONTENT}<b>{this.props.strings.INFO_CONTENT_2}</b></p>
                <h6>{this.props.strings.INFO_BOX_HEADER} <a href="https://www.gnb.ca/coronavirus">www.gnb.ca/coronavirus</a></h6>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
    }
}

const ConnectedCovidInfo = connect(
    mapStateToProps
)(CovidInfo);
export default ConnectedCovidInfo;